import { useState } from "react";
import { BarChart3, LogOut, Users } from "lucide-react";
import { api } from "../../lib/api";
import { BRAND } from "../../config/brand";
import { CrmPanel } from "./crm/CrmPanel";
import { AdminDashboard } from "./AdminDashboard";

const TABS = [
  { id: "crm", label: "Clients", icon: Users },
  { id: "taps", label: "App taps", icon: BarChart3 },
];

export const AdminShell = ({ me, onLogout }) => {
  const [tab, setTab] = useState("crm");
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    onLogout();
  };

  return (
    <div className="mx-auto max-w-7xl px-4 pb-20 pt-6 sm:px-8" data-testid="admin-shell">
      <header className="flex items-center justify-between gap-3">
        <div className="flex min-w-0 items-center gap-3">
          <img src={BRAND.logoSmall} alt="SYNrise" className="h-11 w-11 shrink-0" />
          <div className="min-w-0">
            <h1 className="flex items-center gap-2 font-display text-xl font-bold text-zinc-50">Admin Area{me?.role === "owner" && <span data-testid="admin-owner-badge" className="rounded-full border border-gold/40 bg-gold/15 px-2 py-0.5 font-mono text-[11px] font-medium text-gold">OWNER</span>}</h1>
            <p className="truncate text-xs text-zinc-400" data-testid="admin-current-user">Signed in as <span className="text-gold">{me?.name}</span></p>
          </div>
        </div>
        <button onClick={logout} data-testid="admin-logout-button" className="flex h-10 shrink-0 items-center gap-2 rounded-full border border-white/10 px-4 text-xs font-semibold text-zinc-300 transition-colors hover:text-gold">
          <LogOut className="h-3.5 w-3.5" /> Log out
        </button>
      </header>

      <nav className="mt-6 inline-flex rounded-full border border-white/10 bg-white/[0.04] p-1" data-testid="admin-tabs">
        {TABS.map(({ id, label, icon: Icon }) => (
          <button key={id} onClick={() => setTab(id)} data-testid={`admin-tab-${id}`}
            className={`flex h-10 items-center gap-2 rounded-full px-5 text-sm font-semibold transition-colors ${tab === id ? "bg-gold text-ink" : "text-zinc-400 hover:text-zinc-100"}`}>
            <Icon className="h-4 w-4" /> {label}
          </button>
        ))}
      </nav>

      <div className="mt-6">
        {tab === "crm" ? <CrmPanel me={me} /> : <AdminDashboard onLogout={onLogout} />}
      </div>
    </div>
  );
};
